module.exports = __webpack_public_path__ + "img/JobApplication.25d48efc.svg";